<template>
  <div>
    <form id="loginForm" @submit="submitForm($event)" novalidate>
      <template v-if="showInputs">
        <div class="notification is-danger" v-if="generalError && showError">
          {{ generalError }}
        </div>
        <div class="field">
          <label for="email" class="label">Email</label>
          <div class="control has-icons-left">
            <input
              id="email"
              ref="email"
              required="required"
              name="email"
              placeholder="john.doe@example.com"
              class="input"
              :class="{ 'is-danger': !email.valid }"
              type="email"
              v-model="user.email"
            />
            <span class="icon is-small is-left">
              <i class="fas fa-envelope"></i>
            </span>
          </div>
          <p class="help" :class="{ 'is-danger': !email.valid }">
            {{ email.errorMessage }}
          </p>
        </div>
        <div class="field">
          <label class="label">Password</label>
          <div class="control has-icons-left">
            <input
              id="password"
              ref="password"
              required="required"
              minlength="6"
              maxlength="25"
              name="password"
              placeholder="Password"
              class="input"
              :class="{ 'is-danger': !password.valid }"
              type="password"
              v-model="user.password"
            />
            <span class="icon is-small is-left">
              <i class="fas fa-lock"></i>
            </span>
          </div>
          <p class="help" :class="{ 'is-danger': !password.valid }">
            {{ password.errorMessage }}
          </p>
        </div>
      </template>
      <div class="field">
        <button
          type="submit"
          class="button is-fullwidth is-primary text-cthis.$APItalize"
        >
          Log in
        </button>
      </div>
      <div class="field">
        <router-link to="/forgot" class="link has-text-grey">
          Forgot your password?
        </router-link>
      </div>
    </form>
  </div>
</template>
<script>
export default {
  name: 'LoginForm',
  props: {
    redirect: {
      type: Boolean,
      default: true
    },
    isHidden: {
      type: Boolean,
      default: false
    },
    showError: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      showInputs: !this.isHidden,
      user: {
        email: '',
        password: ''
      },
      generalError: null,
      email: {
        valid: true,
        errorMessage: ''
      },
      password: {
        valid: true,
        errorMessage: ''
      }
    };
  },
  watch: {
    isHidden(newVal) {
      if (newVal) {
        this.showInputs = false;
      }
    }
  },
  methods: {
    submitForm(evt) {
      evt.preventDefault();
      if (!this.showInputs) {
        this.showInputs = true;
        this.$nextTick(() => {
          this.$emit('onShowInputs', {
            evt: this.showInputs,
            el: this.$refs.email
          });
        });
        return;
      }
      let form = this.$el.querySelector('#loginForm');
      let fields = [
        {
          field: this.$refs.email,
          validation: this.email
        },
        {
          field: this.$refs.password,
          validation: this.password
        }
      ];
      if (form.checkValidity()) {
        let body = {
          email: this.user.email,
          password: this.user.password
        };
        this.$axios
          .post(this.$API.signIn, body)
          .then(response => {
            response.data.token = response.headers.auth;
            // Set the this.$axios token
            this.$axios.defaults.headers.common['auth'] = response.headers.auth;
            this.$store.commit('auth/setUser', response.data);
            if (this.redirect) {
              const path =
                this.$route.query?.from ||
                this.$route.query?.returnTo ||
                '/dashboard';
              if (path.indexOf('/visualizer/') !== -1) {
                window.location = path;
              } else {
                this.$router.push(path);
              }
            }
            this.$emit('onSuccess', response.data);
          })
          .catch(error => {
            console.error(error);
            fields.forEach(field => {
              field.validation.valid = true;
              field.validation.errorMessage = '';
            });
            this.generalError =
              error.response && error.response.data
                ? error.response.data.error || error.response.data
                : 'The Email or Password provided are incorrect.';
            this.$emit('onError', this.generalError);
            return this.generalError;
          });
      } else {
        fields.forEach(field => {
          field.validation.valid = field.field.checkValidity();
          field.validation.errorMessage = field.field.validationMessage;
        });
      }
    }
  }
};
</script>
